'use strict';

var _baseUrl = null;

function getBaseUrl() {
	if (_baseUrl === null) {
		var bases = document.getElementsByTagName('base');
		if (bases.length > 0) {
			_baseUrl = bases[0].href;
		}
	}
	return _baseUrl;
}

var absoluteUrlRegExp = new RegExp('^(?:[a-z]+:)?//', 'i');

function baseUrl(url) {
	if (absoluteUrlRegExp.test(url)) {
		return url;
	}
	return getBaseUrl() + url;
}

module.exports = baseUrl;